<app-grid-layout class="scroll" *ngIf="gridData && showListingPage" [gridData]="gridData"
  [isChangeDetected]="isChangeDetected" [TableName]="'Import History'" [paginationUrl]="paginationUrl"
  [selectedRange]="selectedSizeToShowData" [searchText]="searchString" (refreshDataEmmiter)="refreshData()"
  (showNumberOfRecordsEmmiter)="onSelectSizeData($event)" (deleteDetailEmmiter)="deleteRecords($event)"
  (deleteMultipleRecordsEmmiter)="deleteMultipleRecord($event)" (searchDataEmitter)="searchData($event)"
  (exportEmmiter)="exportReport($event)" (emmitPagination)="pageNavigation($event)" (addRecordEmmiter)="addRecord()"
  (editDetailEmmiter)="editRecord($event)" (detailsEmmiter)="showDatails($event)"
  (sortAsendingEmmiter)="sortAsending($event)" (sortDesendingEmmiter)="sortDesending($event)"
  (paginationDataEmmiter)="pageChange($event)" (detailsWithColumn)="showDetailsWithColumn($event)"
  (backbtnEmmiter)="backBtn()">
</app-grid-layout>